module.exports = __webpack_public_path__ + "static/media/final-02.cf72bf5f.svg";